module.exports = __webpack_public_path__ + "img/14.3c702365.svg";